/**
 * 화면 구현
 */
import SbsPlayerLogger from '../../utils/logger';
import { FullScreen } from '../../common';
import { SbsPlayerGlobal } from '../../common/global';

customElements.define(
  'sbs-player-dialog-vod-preview-end',
  class extends HTMLElement {
    constructor() {
      super();
      this.visible = false;
    }

    set visible(value) {
      this._visible = value;
      this.render();
    }

    get visible() {
      return this._visible;
    }

    static get observedAttributes() {
      return ['title', 'html'];
    }

    async attributeChangedCallback(name, oldValue, newValue) {
      try {
        if (name === 'title' && oldValue !== newValue) {
          this.title = newValue;
        }
        if (name === 'html' && oldValue !== newValue) {
          this.html = newValue;
        }
      } catch (error) {
        console.log(error);
      }
    }

    async connectedCallback() {
      try {
        this.render();
      } catch (error) {
        console.log(error);
      }
    }

    disconnectedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    adoptedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    render() {
      try {
        const { info } = SbsPlayerGlobal.state.data;
        const imageUrl =
          info.defaultimage ||
          info.thumbimg ||
          info.thumbs['640'] ||
          info.program_image;
        this.innerHTML = `<img src="${imageUrl}" style="width: 100%;
          height: 100%;
          object-fit: contain;
          position: absolute;
          top: 0;
          left: 0;
          display: ${imageUrl ? 'block' : 'none'};
        " />
        <div class="playerDialogClip_w current" role="dialog">
          <div class="playerDialogContents">
            <div class="playerDialogTop">
              <p class="playerDialogTop-text">3분 미리보기가 종료되었습니다.
                <strong class="txt01">Aha 멤버십으로 자유롭게 시청하세요.</strong>
                <span class="txt02">(광고없는 모든 영상 무제한 시청)</span>
              </p>
            </div>
            <div class="playerLiveBtns_w">
              <a href="javascript:void(0);" class="btn_bgGreen">Aha 멤버십 가입하기</a>
            </div>
          </div>
          <sbs-player-fullscreen></sbs-player-fullscreen>
      </div>`;

        this.styles();
        this.event();
      } catch (error) {
        console.log(error);
      }
    }

    styles() {
      try {
        if (SbsPlayerGlobal.state.is_mobile) this.style.paddingTop = `56.2%`;
      } catch (error) {
        console.log(error);
      }
    }

    event() {
      try {
        this.fullscreen = new FullScreen(this);

        const PASS_URL = SbsPlayerGlobal.development
          ? 'https://web.golf.developers.sbs.co.kr/membership'
          : 'https://golf.sbs.co.kr/membership';

        this.querySelectorAll('a').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            
            // 모바일 앱 웹뷰 대응
            if (window.webkit && window.webkit.messageHandlers) {
              // iOS WKWebView
              window.webkit.messageHandlers.openURL?.postMessage(PASS_URL);
            } else if (window.Android && window.Android.openURL) {
              // Android WebView
              window.Android.openURL(PASS_URL);
            } else {
              // 일반 웹브라우저
              window.open(PASS_URL, '_blank');
            }
          });
        });

        const fullscreenElement = this.querySelector('sbs-player-fullscreen');
        fullscreenElement.addEventListener(
          'button-toggle-fullscreen',
          (event) => {
            this.fullscreen.toggle();
          }
        );
      } catch (error) {
        console.log(error);
      }
    }
  }
);
